import { passwordDecoder } from "utils/passwordEncoder";
import ApiService from "./ApiService";

export async function apiKycDetails(data) {
  return ApiService.fetchData({
    url: "/customers/getKYCDetails",
    method: "post",
    data,
  });
}

export async function apiVerifyAadhaarOTP(data) {
  return ApiService.fetchData({
    url: "/customers/verifyAadhaarDetails",
    method: "post",
    data,
  });
}

export async function apiConsentNewLoanOTP(data) {
  return ApiService.fetchData({
    url: "/customers/loans/consentNewLoanSENDOTP",
    method: "post",
    data,
  });
}

export async function apiVerifyConsentNewLoanOTP(data) {
  return ApiService.fetchData({
    url: "/customers/loans/consentNewLoanSVERIFYOTP",
    method: "post",
    data,
  });
}

export async function apiConsentSanctionSENDOTP(data) {
  return ApiService.fetchData({
    url: "/customers/loans/consentSanctionSENDOTP",
    method: "post",
    data,
  });
}

export async function apiVerifyConsentSanctionOTP(data) {
  return ApiService.fetchData({
    url: "/customers/loans/consentSanctionVERIFYOTP",
    method: "post",
    data,
  });
}

export async function apiAddLoan(data) {
  return ApiService.fetchData({
    url: "/customers/loans/addLoanDetails",
    method: "post",
    data,
  });
}

export async function apiAddLoanCPO(data) {
  return ApiService.fetchData({
    url: "/cpo/updateLoanDetails",
    method: "post",
    data,
  });
}

export async function uploadDocument(data) {
  return ApiService.fetchData({
    url: "/customers/loans/uploadLandDocument",
    method: "post",
    data,
  });
}

export async function apiCustomerDetails(params) {
  const response = await ApiService.fetchData({
    url: "/customers/getCustomerDetails",
    method: "GET",
    params,
  });
  const decryptedResults = passwordDecoder(response?.data?.results);
  const parsedDecryptedResults = JSON.parse(decryptedResults);
  response.data.results = parsedDecryptedResults;
  return response;
}

export async function apiGetTemplate(params) {
  return ApiService.fetchData({
    url: "/organizations/getTemplate",
    method: "GET",
    params,
  });
}

export async function updateLandDetails(data) {
  return ApiService.fetchData({
    url: "/customers/loans/updateLandDetails",
    method: "POST",
    data,
  });
}

export async function updateLanguage(data) {
  return ApiService.fetchData({
    url: "/settings/language",
    method: "POST",
    data,
  });
}

export async function getPredesignedLandDocument(data) {
  return ApiService.fetchData({
    url: "/customers/loans/getPresignedUrlForLandDocument",
    method: "POST",
    data,
  });
}
